import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import initialState from '../helpers/form-helpers/initial-state';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import FormBuilder from '../helpers/form-builder';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import TheOneClubIntro from './TheOneClubIntro';
import TheOneClubMotivation from './TheOneClubMotivation';
import TheOneClubFAQ from './TheOneClubFAQ';
import { deepCopyObject } from '../../utils/obj-utils';
import ConfirmationModal from '../../common/utility/ConfirmationModal';
import './the-one-club.scss';
import LeaveOneClubModalBody from './LeaveOneClubModalBody';
import { hasValue } from '../../../../../general/js/general-helpers';
import { updateUserDataCookie } from '../../utils/user-data-cookie/user-data-cookie-helpers';

class TheOneClub extends Component {
    constructor(props) {
        super(props);

        const { formData, accountData } = props;
        const copyOfAccountData = deepCopyObject(accountData);
        const copyOfFormData = deepCopyObject(formData);
        this.state = {
            ...initialState.theOneClubFormState,
            formData: copyOfFormData,
            becomeOneClubMember: copyOfFormData.becomeOneClubMember.defaultValue,
            accountData: copyOfAccountData,
            shouldLeaveOneClub: false
        };

        this.displayTheOneClubForm = this.displayTheOneClubForm.bind(this);
        this.displayConfirmationModal = this.displayConfirmationModal.bind(this);
        this.handleUserDetailsUpdateSuccess = this.handleUserDetailsUpdateSuccess.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleJoinNowClick = this.handleJoinNowClick.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.scrollToForm = this.scrollToForm.bind(this);
        this.submitUserDetailsData = this.submitUserDetailsData.bind(this);
        this.updateFormData = this.updateFormData.bind(this);
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.handleApproveLeaveOneClub = this.handleApproveLeaveOneClub.bind(this);
        this.handleLeaveOneClubCheck = this.handleLeaveOneClubCheck.bind(this);

        this.formReferences = formScrollHelpers.getFormReferences(formData);
    }

    componentWillReceiveProps(nextProps) {
        const { isSaving } = this.state;
        const {
            loading,
            isUserDetailsUpdatedSuccessful,
            formData
        } = nextProps;
        const { hasOneClubAccount } = formData;

        if (isSaving &&
            !loading &&
            isUserDetailsUpdatedSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUserDetailsUpdateSuccess);
        }

        if (isSaving &&
            !loading &&
            !isUserDetailsUpdatedSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false));
        }

        if (this.state.formData.hasOneClubAccount !== hasOneClubAccount) {
            this.setState((prevState) => ({
                formData: {
                    ...prevState.formData,
                    hasOneClubAccount
                }
            }));
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.theOneClubFormState);
        actions.resetUserDetailsFormState();
    }

    componentDidMount() {
        const { formData } = this.state;
        this.setState(formStateHelpers.updateFormFields(formData));
        this.updateFormData();
    }

    updateFormData() {
        const { accountData } = this.props;
        const { becomeOneClubMember, shouldLeaveOneClub } = this.state;
        const copyOfFormData = deepCopyObject(this.state.formData);
        const { hasTicketingAccount } = copyOfFormData;
        const { isOneClubMember } = accountData;

        if (isOneClubMember &&
            copyOfFormData[formConstants.becomeOneClubMember].defaultValue === true &&
            becomeOneClubMember === false) {
            this.setState(formStateHelpers.toggleKey('shouldLeaveOneClub'));
        }

        copyOfFormData[formConstants.becomeOneClubMember].defaultValue = becomeOneClubMember;

        if (!hasTicketingAccount) {
            copyOfFormData[formConstants.title].isHidden = !becomeOneClubMember;
            copyOfFormData[formConstants.dateOfBirth].isHidden = !becomeOneClubMember;
            copyOfFormData[formConstants.country].isHidden = !becomeOneClubMember;
            copyOfFormData[formConstants.county].isHidden = !becomeOneClubMember;
            copyOfFormData[formConstants.state].isHidden = !becomeOneClubMember;
            copyOfFormData[formConstants.postcode].isHidden = !becomeOneClubMember;
        }

        copyOfFormData[formConstants.venues].isHidden = !becomeOneClubMember;
        copyOfFormData[formConstants.oneClubTermsAndServices].isHidden = !becomeOneClubMember;

        this.setState(formStateHelpers.updateFormData(copyOfFormData), () => {
            if (shouldLeaveOneClub) {
                this.setState(formStateHelpers.toggleKey('shouldLeaveOneClub'));
            }
        });
    }

    handleUserDetailsUpdateSuccess() {
        const {
            refreshAccountPage,
            actions,
            formData,
            accountData,
            userAddedToAddressBookSuccessful,
            saveUserToAddressBookErrorMessages
        } = this.props;
        const { becomeOneClubMember } = this.state;
        const { isOneClubMember } = hasValue(accountData) ? accountData : { isOneClubMember: false };

        if (!userAddedToAddressBookSuccessful && !hasValue(saveUserToAddressBookErrorMessages) && !isOneClubMember && becomeOneClubMember) {
            actions.saveUserToAddressBook(formData, accountData);
        }

        formScrollHelpers.scrollToField(this.formMessageRef);

        updateUserDataCookie(true, true);
        this.updateFormData();
        refreshAccountPage(false);
    }

    handleJoinNowClick(event) {
        event.preventDefault();
        this.scrollToForm();

        const { becomeOneClubMember } = this.state;
        if (becomeOneClubMember) {
            return;
        }

        this.setState(formStateHelpers.toggleKey(formConstants.becomeOneClubMember), this.updateFormData);
    }

    scrollToForm() {
        formScrollHelpers.scrollToField(this.formReferences[formConstants.becomeOneClubMember]);
    }

    handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.state;
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitUserDetailsData);
    }

    submitUserDetailsData() {
        const { actions, accountData } = this.props;
        const { isOneClubMember } = accountData;
        const { formData, becomeOneClubMember } = this.state;
        const {
            callBackUrl,
            joinTheOneClubActionSuccessText,
            leaveTheOneClubActionSuccessText,
            updateDetailsActionSuccessText
        } = formData;

        let formattedActionSuccessText = isOneClubMember ?
            updateDetailsActionSuccessText :
            joinTheOneClubActionSuccessText || formMessageConstants.updateUserDetailsSuccessText;

        if (!becomeOneClubMember) {
            formattedActionSuccessText = leaveTheOneClubActionSuccessText || formMessageConstants.updateUserDetailsSuccessText;
        }

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);

        this.setState(formStateHelpers.updateOneClubTermsAndConditions(becomeOneClubMember),
            () => {
                actions.joinTheOneClub({
                    userDetails: this.state,
                    accountData,
                    actionSuccessText: formattedActionSuccessText,
                    callBackUrl
                });
                this.updateFormData();
            });
    }

    displayConfirmationModal() {
        const {
            shouldLeaveOneClub,
            formData,
            leaveOneClubCheck
        } = this.state;
        const {
            leaveTheOneClubDialogBoxTitle,
            leaveTheOneClubDialogBoxMessage,
            leaveTheOneClubDialogBoxAgreeButton,
            leaveOneClubDialogBoxCheckText
        } = formData;

        return <ConfirmationModal
            isOpen={shouldLeaveOneClub}
            inputText={leaveTheOneClubDialogBoxAgreeButton}
            onModalClose={this.toggleConfirmationModal}
            onApproveClick={this.handleApproveLeaveOneClub}
            isApproveDanger={true}
            isApproveButtonDisabled={!leaveOneClubCheck}
            onCancelClick={this.toggleConfirmationModal}
            isCancelButtonDisabled={true}>
            <LeaveOneClubModalBody
                leaveTheOneClubDialogBoxTitle={leaveTheOneClubDialogBoxTitle}
                leaveTheOneClubDialogBoxMessage={leaveTheOneClubDialogBoxMessage}
                leaveOneClubDialogBoxCheckText={leaveOneClubDialogBoxCheckText}
                leaveOneClubCheck={leaveOneClubCheck}
                onLeaveOneClubClick={this.handleLeaveOneClubCheck}>
            </LeaveOneClubModalBody>
        </ConfirmationModal>;
    }

    toggleConfirmationModal() {
        const { leaveOneClubCheck } = this.state;
        if (leaveOneClubCheck) {
            this.setState(formStateHelpers.toggleKey('leaveOneClubCheck'));
        }

        this.setState(formStateHelpers.toggleKey('shouldLeaveOneClub'));
        this.setState(formStateHelpers.toggleKey('becomeOneClubMember'), this.updateFormData);
    }

    handleApproveLeaveOneClub(event) {
        event.preventDefault();
        const { leaveOneClubCheck } = this.state;
        if (!leaveOneClubCheck) {
            return;
        }
        this.setState(formStateHelpers.toggleKey('leaveOneClubCheck'));
        this.setState(formStateHelpers.toggleKey('shouldLeaveOneClub'), this.handleValidationResult);
        document.getElementById('overlay').classList.remove('is-visible');
        document.documentElement.classList.remove('is-blocked');
    }

    handleLeaveOneClubCheck() {
        this.setState(formStateHelpers.toggleKey('leaveOneClubCheck'));
    }

    displayTheOneClubForm() {
        const { formData, availableCounties, availableStates } = this.state;
        const { county, state } = formData;
        const { hasOneClubAccount, joinTheOneClubInputLabelText } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        copyOfFormData[formConstants.becomeOneClubMember].label = hasOneClubAccount ?
            joinTheOneClubInputLabelText :
            this.state.formData[formConstants.becomeOneClubMember].label;

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => {
                const eventTarget = event.target;
                const fieldName = eventTarget.name;
                const fieldData = formData[fieldName];
                this.setState(formStateHelpers.handleFieldChangeWithValidation(eventTarget, fieldData), this.updateFormData);
            },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state));
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const {
            loading,
            updateUserDetailsMessages,
            isUserDetailsUpdatedSuccessful,
            accountData
        } = this.props;
        const { isOneClubMember } = accountData;
        const { formData } = this.state;
        const {
            formTitle,
            introText,
            theOneClubImageSource,
            theOneClubImageText,
            theOneClubMotivationTitle,
            theOneClubMotivationImageSource,
            theOneClubReasons,
            theOneClubFAQTitle,
            theOneClubFAQs
        } = formData;
        const { isSaving, becomeOneClubMember } = this.state;

        return (
            <Fragment>
                <h1>{formTitle}</h1>
                <div className='the-one-club'>
                    {isSaving || loading ? <FormSpinner >/</FormSpinner> : null}
                    <TheOneClubIntro
                        text={introText}
                        imageSource={theOneClubImageSource}
                        imageText={theOneClubImageText}></TheOneClubIntro>
                    <div className='toc-form'>
                        <form onSubmit={this.handleSubmit}>
                            <FormMessage
                                isSuccessMessage={isUserDetailsUpdatedSuccessful}
                                messages={updateUserDetailsMessages}></FormMessage>
                            {this.displayTheOneClubForm()}
                            {this.displayConfirmationModal()}
                            <SSOFormFooter
                                onSubmit={this.handleSubmit}
                                isHidden={!becomeOneClubMember}
                                footerButtonText={isOneClubMember ?
                                    formMessageConstants.updateOneClubDetails :
                                    formMessageConstants.submitOneClubFormButtonText}
                            ></SSOFormFooter>
                        </form>
                    </div>
                    <TheOneClubMotivation
                        title={theOneClubMotivationTitle}
                        imageSource={theOneClubMotivationImageSource}
                        reasons={theOneClubReasons}></TheOneClubMotivation>
                    <TheOneClubFAQ title={theOneClubFAQTitle} questions={theOneClubFAQs} ></TheOneClubFAQ>
                </div>
            </Fragment >
        );
    }
}

TheOneClub.propTypes = {
    formData: PropTypes.object.isRequired,
    accountData: PropTypes.object.isRequired,
    refreshAccountPage: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUserDetailsUpdatedSuccessful: state.userAccount.isUserDetailsUpdatedSuccessful,
        updateUserDetailsMessages: state.userAccount.updateUserDetailsMessages,
        userAddedToAddressBookSuccessful: state.userAccount.userAddedToAddressBookSuccessful,
        saveUserToAddressBookErrorMessages: state.userAccount.saveUserToAddressBookErrorMessages
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            joinTheOneClub: bindActionCreators(userAccountActions.joinTheOneClub, dispatch),
            resetUserDetailsFormState: bindActionCreators(userAccountActions.resetUserDetailsFormState, dispatch),
            saveUserToAddressBook: bindActionCreators(userAccountActions.saveUserToAddressBook, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TheOneClub);
